const LogoutHelper = () => {
  const preserveKeys = ['rememberMe', 'darkMode', 'username', 'password', 'soundOn'];
  const keysToRemove = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!preserveKeys.includes(key)) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => localStorage.removeItem(key));
};

export default LogoutHelper;
